import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, MailOpen, Trash2, Reply } from "lucide-react";
import api from "@/lib/api";

export default function MessagesTab() {
  const [messages, setMessages] = useState([]);

  const load = () => api.get("/admin/messages").then((r) => setMessages(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.put(`/admin/messages/${id}/read`); load(); };
  const del = async (id) => { await api.delete(`/admin/messages/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-messages">
      <h1 className="font-display font-bold text-3xl mb-1">Messages</h1>
      <p className="text-ink/60 mb-6">Messages sent from your website's contact form.</p>

      {messages.length === 0 ? (
        <div className="brut-card p-6 text-ink/60">No messages yet.</div>
      ) : (
        <div className="space-y-4">
          {messages.map((m) => (
            <div key={m.id} className={`brut-card p-5 ${m.read ? "" : "bg-sun/20"}`} data-testid={`message-${m.id.slice(0,8)}`}>
              <div className="flex flex-wrap justify-between gap-2 items-start">
                <div>
                  <div className="font-display font-bold text-lg flex items-center gap-2">
                    {m.read ? <MailOpen className="w-4 h-4 text-ink/40" /> : <Mail className="w-4 h-4 text-bubble" />}
                    {m.name}
                  </div>
                  <a href={`mailto:${m.email}`} className="text-sm text-sky hover:underline">{m.email}</a>
                </div>
                <span className="text-xs text-ink/40">{new Date(m.created_at).toLocaleString()}</span>
              </div>
              <p className="mt-3 text-ink/90 whitespace-pre-line">{m.message}</p>
              <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t-2 border-dashed border-ink/20">
                <a href={`mailto:${m.email}?subject=Re: your message to Art by Jason`}
                  className="brut-btn !py-2 !px-4 bg-sky text-sm" data-testid={`reply-${m.id.slice(0,8)}`}>
                  <Reply className="w-4 h-4" /> Reply by email
                </a>
                {!m.read && (
                  <button onClick={() => markRead(m.id)} className="brut-btn !py-2 !px-4 bg-white text-sm" data-testid={`mark-read-${m.id.slice(0,8)}`}>
                    <MailOpen className="w-4 h-4" /> Mark read
                  </button>
                )}
                <button onClick={() => del(m.id)} className="brut-btn !py-2 !px-4 bg-white text-sm" data-testid={`delete-message-${m.id.slice(0,8)}`}>
                  <Trash2 className="w-4 h-4" /> Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
